import {
  basePathRewrite,
  loadHeadScripts,
  loadLoginScript,
} from '@components/common';
import { IJobCount } from '@components/shared.types';
import { track } from './eventTrack';
import { getENVPath } from 'helper';

interface ISoftRegModalProps {
  config: any;
  jobCardData: any;
  isFromWizardPage: boolean;
  isMobileView: boolean;
  hiring_count: IJobCount | any;
  isExperiment?: boolean;
  remoteTypeCount?: any;
  isExpRemoteTypeVariant?: boolean;
}

export default function softRegModalProps(props: ISoftRegModalProps) {
  const {
    config,
    jobCardData,
    isFromWizardPage,
    isMobileView,
    hiring_count,
    isExperiment,
    remoteTypeCount,
    isExpRemoteTypeVariant
  } = props;

  return {
    config,
    trackFunction: track,
    basePathRewrite,
    loadLoginScript,
    loadHeadScripts,
    jobDataCount: jobCardData?.jobs?.totalCount,
    isFromWizardPage,
    isCloseAllowed: isMobileView || !isFromWizardPage,
    hiringCount: hiring_count,
    isMobileView,
    returnUrl: isFromWizardPage
      ? `${getENVPath().NEXT_PUBLIC_ROOT_URL}/payment/index`
      : '',
    isGoogleLogin: true,
    isAppleLogin: true,
    isExperiment,
    remoteTypeCount,
    isExpRemoteTypeVariant
  };
}
